function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M405.906,48.241c-1.719-1.282-3.49-2.532-5.323-3.752c-4.865-3.262-11.469-1.959-14.74,2.908 c-3.281,4.856-2.021,11.474,2.813,14.788c1.458,1,2.896,2.011,4.313,3.033c58.625,43.552,41.021,129.957,34.063,155.885 c-20.948,78.068-72.719,77.422-74.563,77.474c-0.729-0.063-1.469,0.031-2.135,0.125c-0.719,0.073-16.99,2.366-30.813-9.536 c-13.646-11.745-20.854-34.329-20.854-65.301c0-77.349,55.76-106.654,58.135-107.863c2.719-1.376,4.729-3.866,5.5-6.816 c0.771-2.949,0.26-6.097-1.427-8.629l-21.333-32.015c-2.979-4.471-8.854-6.013-13.646-3.627 c-11.198,5.607-24.719,16.268-35.688,25.783c2.958-19.103,7.844-33.995,7.917-34.214c1.094-3.314,0.51-6.972-1.594-9.765 l-32-42.687c-4.021-5.378-13.042-5.378-17.063,0l-32,42.687c-2.104,2.793-2.688,6.451-1.594,9.765 c0.073,0.219,4.958,15.111,7.917,34.214c-10.969-9.515-24.49-20.176-35.688-25.783c-4.802-2.387-10.656-0.844-13.646,3.627 l-21.333,32.015c-1.698,2.543-2.219,5.701-1.438,8.66c0.792,2.96,2.802,5.44,5.542,6.805 c0.583,0.292,58.104,29.962,58.104,107.842c0,30.973-7.208,53.556-20.854,65.301c-13.833,11.912-30.125,9.598-30.729,9.546 c-0.667-0.104-1.438-0.198-2.135-0.135c-1.865,0.261-53.698,0.625-74.646-77.474C78.01,195.175,60.406,108.801,119.01,65.239 c1.438-1.042,2.896-2.063,4.365-3.074c4.833-3.314,6.083-9.921,2.792-14.778c-3.271-4.825-9.833-6.128-14.75-2.897 c-1.813,1.209-3.573,2.449-5.271,3.71C39.563,96.368,0,173.529,0,255.88C0,397.103,114.844,512,256,512s256-114.897,256-256.12 C512,173.56,472.458,96.42,405.906,48.241z M256,490.667C126.604,490.667,21.333,385.396,21.333,256 c0-45.531,13.208-89.333,37.094-126.615c-7.104,40.563,1.385,80.427,5.938,97.375c24.083,89.781,85.667,93.25,95,93.25 c0,0,0.01,0,0.021,0c5.271,0.646,27.417,2.031,46.635-14.25c19.01-16.104,28.646-43.604,28.646-81.76 c0-70.385-40.219-106.99-59.677-120.583l9.646-14.469c18.906,12.448,42.219,35.656,42.49,35.927 c3.063,3.052,7.667,3.948,11.625,2.313c3.99-1.656,6.583-5.542,6.583-9.854c0-25.76-6.417-51.104-9.552-61.938L256,28.448 l20.219,26.948c-3.135,10.833-9.552,36.177-9.552,61.938c0,4.313,2.594,8.198,6.583,9.854c3.99,1.615,8.573,0.74,11.625-2.313 c0.271-0.271,23.583-23.479,42.49-35.927l9.646,14.469C317.552,117.01,277.333,153.615,277.333,224 c0,38.156,9.635,65.656,28.646,81.76c19.219,16.281,41.385,14.896,46.635,14.25c0.01,0,0.01,0,0.021,0 c9.344,0,70.917-3.479,95-93.25c4.552-16.948,13.042-56.813,5.938-97.375c23.885,37.281,37.094,81.083,37.094,126.615 C490.667,385.396,385.396,490.667,256,490.667z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgRebelAlliance = function SvgRebelAlliance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRebelAlliance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rebel-alliance.8fffe775.svg";
export { ForwardRef as ReactComponent };